import React, { useState } from 'react'
import DefaultLink from '../../components/DefaultLink'
import BoardModal from './BoardModal'

export default function BoardDirectors({ boardData }) {

  const [selectdMember, setSelectedMember] = useState(null);

  return (
    <section className='team-board-directors'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-lg-12'>
            <h3 className='heading center-heading'>Board of directors</h3>
          </div>
          {boardData.map((item, index) => (
            <div className='col-lg-4 col-md-6' key={index}>
              <div className='team-director-card'>
                <div className='director-card-content'>
                  <img src={item?.img} alt={item?.name} />
                  <div>
                    <span>{item?.name}</span>
                    <p>{item?.role}</p>
                  </div>
                </div>
                <DefaultLink to={""} onClick={() => setSelectedMember(item)} text={"Read More"} />
              </div>
            </div>
          ))}
        </div>

        <BoardModal data={selectdMember} onClose={() => setSelectedMember(null)} />
      </div>

    </section>
  )
}